import { ReactElement } from 'react';

import ReportsVisitsSectionContextProvider from './Context';
import ReportsVisitsSectionFilters from './Filters';
import ReportsVisitsSectionCharts from './Charts';
import ReportsVisitsSectionWidgets from './Widgets';

import {
  ReportsVisitsSectionContainer,
  ReportsVisitsSectionContent,
} from './styles';

const ReportsVisitsSection = (): ReactElement => (
  <ReportsVisitsSectionContextProvider>
    <ReportsVisitsSectionContainer>
      <ReportsVisitsSectionFilters />

      <ReportsVisitsSectionContent>
        <ReportsVisitsSectionCharts />

        <ReportsVisitsSectionWidgets />
      </ReportsVisitsSectionContent>
    </ReportsVisitsSectionContainer>
  </ReportsVisitsSectionContextProvider>
);

export default ReportsVisitsSection;
